import { render, staticRenderFns } from "./ClassificationComponent.vue?vue&type=template&id=1978e08e&scoped=true"
import script from "./ClassificationComponent.vue?vue&type=script&lang=js"
export * from "./ClassificationComponent.vue?vue&type=script&lang=js"
import style0 from "./ClassificationComponent.vue?vue&type=style&index=0&id=1978e08e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1978e08e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1978e08e')) {
      api.createRecord('1978e08e', component.options)
    } else {
      api.reload('1978e08e', component.options)
    }
    module.hot.accept("./ClassificationComponent.vue?vue&type=template&id=1978e08e&scoped=true", function () {
      api.rerender('1978e08e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/appellation/ClassificationComponent.vue"
export default component.exports